globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.CookiesUsage = (function() {
  function CookiesUsage() {
    this.init();
  }

  CookiesUsage.prototype = {
    init: function() {
      this.events();
    },
    events: function() {
      var $cookiesUsageMessageContainer = $('#cookies-usage-message');

      $cookiesUsageMessageContainer.on('click', 'button', function() {
        var $this = $(this);

        if($this.hasClass('refuse')) {
          utils.cookies.create('accept_cookies_usage', false, 8760);
        } else {
          utils.cookies.create('accept_cookies_usage', true, 8760);
        }

        if($this.hasClass('allow') || $this.hasClass('refuse')) {
          window.location.reload();
        } else {
          $cookiesUsageMessageContainer.fadeOut('fast');
        }
      });
    }
  }

  return CookiesUsage;
})();
